import { render, staticRenderFns } from "./InvestmentsPerformanceLineChart.vue?vue&type=template&id=5c6aa0c8"
import script from "./InvestmentsPerformanceLineChart.vue?vue&type=script&lang=ts"
export * from "./InvestmentsPerformanceLineChart.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentsPerformanceLineChart.vue?vue&type=style&index=0&id=5c6aa0c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports